// src/js/globals/CopyText.js
//
// "Copy" buttons anywhere on the site: a button with [data-copy="text"]
// copies that text and says so on the button for two seconds. Where the
// clipboard isn't available it selects the button's PREVIOUS SIBLING
// instead, so place the button straight after the element that shows the
// text (<span>hello@…</span><button data-copy="hello@…">Copy</button>).
// Used by the close panel's email line (_markup/objects/closePanel.twig).
//
// A global rather than a behaviour because the buttons sit inside other
// behaviours' nodes, and @spon/core allows one behaviour per node. One
// delegated listener on document covers every page.

const SAID_MS = 2000;

export default function CopyText() {
	const timers = new Map();

	const say = (button, label, msg) => {
		clearTimeout(timers.get(button));
		button.textContent = msg;
		timers.set(
			button,
			setTimeout(() => {
				button.textContent = label;
				timers.delete(button);
			}, SAID_MS)
		);
	};

	const select = (button, label) => {
		const target = button.previousElementSibling;
		if (!target) return;
		const range = document.createRange();
		range.selectNodeContents(target);
		const sel = window.getSelection();
		sel.removeAllRanges();
		sel.addRange(range);
		say(button, label, 'Selected');
	};

	const onClick = e => {
		const button = e.target.closest('[data-copy]');
		if (!button) return;
		// A second click while it still says "Copied" keeps the real label.
		const label = button.dataset.copyLabel || button.textContent;
		button.dataset.copyLabel = label;
		const text = button.dataset.copy;
		if (navigator.clipboard && navigator.clipboard.writeText)
			navigator.clipboard.writeText(text).then(
				() => say(button, label, 'Copied'),
				() => select(button, label)
			);
		else select(button, label);
	};

	document.addEventListener('click', onClick);

	return () => {
		document.removeEventListener('click', onClick);
		timers.forEach(clearTimeout);
	};
}
